import classNames from "classnames";
import { FC, useCallback, useMemo } from "react";

import Modal from "components/Modal";

import { RootStore } from "store";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { getModalCallbacks } from "store/slices/modalCallbacksRegistry";
import { hideModal } from "store/slices/modalSlice";

import ModalCreateGatewayContent, { GatewayFormValues } from "./Content";

import styles from "./styles.module.scss";

type PropTypes = {
  isVisible: boolean;
  className?: string;
  mode?: "create" | "edit";
  id?: number;
  initialData?: GatewayFormValues;
  callbackKey?: string;
};

const WidgetModalCreateGateway: FC<PropTypes> = ({
  isVisible,
  className,
  mode = "create",
  initialData,
  callbackKey,
}) => {
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector((state: RootStore) => state.gateways.isLoading);

  const callbacks = useMemo(() => (callbackKey ? getModalCallbacks(callbackKey) : undefined), [callbackKey]);
  const onSubmit = useMemo(() => callbacks?.onSave, [callbacks]);

  const isCreate = mode === "create";
  const title = isCreate ? "Add new gateway" : "Edit gateway";
  const description = isCreate
    ? "Register a new IoT gateway to your network"
    : "Update gateway information";

  const handleClose = useCallback(() => {
    dispatch(hideModal());
  }, [dispatch]);

  return (
    <Modal title={title} isClose isCloseBg isVisible={isVisible} className={classNames(styles.modal, className)}>
      <ModalCreateGatewayContent
        mode={mode}
        description={description}
        initialData={initialData}
        onSubmit={onSubmit}
        onClose={handleClose}
        isLoading={isLoading}
      />
    </Modal>
  );
};

export default WidgetModalCreateGateway;
